// Turns size chart tables marked with data-unit="cm" / data-unit="in"
// into a unit switcher (e.g. CM | IN). Works in the product collapsible
// rows and in the size guide popup.
(function () {
  if (window.sizeChartUnitsLoaded) return;
  window.sizeChartUnitsLoaded = true;

  function show(container, unit) {
    container.querySelectorAll('table[data-unit]').forEach((table) => {
      table.hidden = table.dataset.unit !== unit;
    });
    container.querySelectorAll('.size-chart-units button').forEach((button) => {
      const active = button.dataset.unit === unit;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active);
    });
  }

  function initSizeChartUnits(container) {
    if (container.dataset.unitsReady) return;
    const tables = container.querySelectorAll('table[data-unit]');
    if (tables.length < 2) return;
    container.dataset.unitsReady = 'true';

    const switcher = document.createElement('div');
    switcher.className = 'size-chart-units';
    switcher.setAttribute('role', 'tablist');
    tables.forEach((table) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('role', 'tab');
      button.dataset.unit = table.dataset.unit;
      button.textContent = table.dataset.unitLabel || table.dataset.unit.toUpperCase();
      switcher.appendChild(button);
    });
    tables[0].parentNode.insertBefore(switcher, tables[0]);
    show(container, tables[0].dataset.unit);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.size-chart-units button');
    if (!button) return;
    event.stopPropagation();
    show(button.closest('.size-chart-units').parentNode, button.dataset.unit);
  });

  function init() {
    document
      .querySelectorAll('.collapsible-content_inner')
      .forEach(initSizeChartUnits);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
